import { globalState } from './globalState'
import { criteriaSelector } from './store'
import { log, logError } from './utils'

export const fetchUnreadOfferNotificationsCount = async (): Promise<void> => {
    const config = globalState.getConfig()
    const store = globalState.getStore()

    if (config.LEGEND_LEVEL_IS_USED && store.legendLevel === undefined) {
        log('Skip fetchUnreadOfferNotificationsCount due to legendLevel is undefined')
        return
    }

    if (!store.isCanvas && store.token && store.unreadOfferNotifsCountUrl) {
        log('fetchUnreadOfferNotificationsCount')
        let unreadCount = 0
        const headers = {
            Authorization: `Bearer ${store.token}`,
        }
        const url = store.unreadOfferNotifsCountUrl
            .replace('{locale}', store.language || '')
            .replace('{zoneId}', store.zoneId || '')
            .replace('{criteria}', encodeURIComponent(JSON.stringify(criteriaSelector(store))))
        try {
            log('fetch', url)
            const resp = await fetch(url, {
                headers,
            })
            if (resp.ok) {
                const data = await resp.json()
                unreadCount = Number(data?.notifCount)
            }
        } catch (error) {
            logError(`cannot fetch ${url}`, error)
        }
        log('setUnseenOffersCounter', unreadCount)
        store.gameApi.invokeFn('setUnseenOffersCounter', unreadCount).catch((error) => {
            logError('setUnseenOffersCounter error:', error)
        })
    }
}
